import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { Flexbox } from '@/ui/flexbox/flexbox';
import RequestSentIllustration from '@/assets/svg/request-solution-request-sent.svg?react';

export const PendingProjectsEmptyState = () => {
  const { t } = useTranslation('projects');

  return (
    <Flexbox
      name="pending-projects-empty-state"
      direction="column"
      justify="center"
      alignItems="center"
    >
      <RequestSentIllustration />
      <EmptyStateTitle>{t`projects.pendingRequests.empty.title`}</EmptyStateTitle>
    </Flexbox>
  );
};

const EmptyStateTitle = styled('h3')`
  font-family: ${({ theme }) => theme.fonts.neue};
  font-size: 24px;
  color: ${({ theme }) => theme.colors.gray.c12};
  text-align: center;
  line-height: 38px;
`;
